var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListPage',{attrs:{"tabName":"owned"}})}
var staticRenderFns = []

export { render, staticRenderFns }